import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isEventTicketLoading = (state: TRootState): boolean =>
  arrayContains(state.eventTicket.openRequests, [
    Actions.findEventTicketRequest.type,
    Actions.findEventTicketsRequest.type,
    Actions.createEventTicketRequest.type,
    Actions.updateEventTicketRequest.type,
    Actions.deleteEventTicketRequest.type,
  ]);
